import { createContext, useContext } from 'react';

interface FilterMessagesContextProps {
  filters: { me: boolean; facilities: string[]; groups: string[] };
  setFilters: (value: FilterMessagesContextProps['filters']) => void;
  sender: string | null;
  setSender: (value: string | null) => void;
  selectedFacilitiesAndFacilitiesFromGroups: string[];
  isLoadingSender: boolean;
}

export const defaultContextValues: FilterMessagesContextProps = {
  filters: { me: false, facilities: [], groups: [] },
  setFilters: () => null,
  sender: null,
  setSender: () => null,
  selectedFacilitiesAndFacilitiesFromGroups: [],
  isLoadingSender: false,
};

export const FilterMessagesContext = createContext<FilterMessagesContextProps>(defaultContextValues);

export const useFilterMessagesContext = () => {
  const context = useContext(FilterMessagesContext);
  if (!context) {
    throw new Error('useFilterMessagesContext should be used inside a FilterMessageOnHubContext');
  }
  return context;
};
